import { createContext } from "react";

/**
 * Context to manage the global game state
 * Includes authentication, online players and active tables
 */
export const GameContext = createContext();
